module.exports = __webpack_public_path__ + "static/media/Animondial.fb5f8236.png";